<!--<p>-->
<!--  The Jalali calendar is a solar calendar that was used in Persia.-->
<!--  Variants of it are still in use in Iran and Afghanistan-->
<!--</p>-->



<div class="w-100 text-center align-items-lg-stretch flex-wrap"
     [ngStyle]="{'text-align': this.apiService.currentDirection === 'ltr'? 'left': 'right'}">
<p class="text-center">{{lblText}}</p>

  <div class="col-12 p-1">

    <button  [value]="newDate"  class="btn large-btn" (click)="isDisabled = !isDisabled" >
<!--      <span >{{dateJalaliWithDay ? '':'انتخاب کنید'}} {{dateJalaliWithDay}}</span>-->
      <span> <i class="fa fa-calendar" style="margin: 5px 90px 0 0;"></i>{{newDate ? newDate:''}} </span>

    </button>
  </div>
  <ngb-datepicker #d  [minDate]="minDate" *ngIf="isDisabled" [(ngModel)]="model" [firstDayOfWeek]="6" (dateSelect)="onClick($event); isDisabled= false"
                 class="m-auto d-bloc bg-white position-relative"
                  style="z-index: 4;margin-top: 38px;"></ngb-datepicker>
</div>





<!--<button class="btn btn-sm btn-outline-primary mr-2" (click)="selectToday()">Select Today</button>-->
<!--<button class="btn btn-sm btn-outline-primary mr-2" (click)="dp.navigateTo()">To current month</button>-->
<!--<button class="btn btn-sm btn-outline-primary mr-2" (click)="dp.navigateTo({year: 1396, month: 4})">To Tir. 1396</button>-->

<!--<hr/>-->

<!--<pre>Model: {{ model | json }}</pre>-->
